import React from 'react';
import styled from 'styled-components';

import { palette } from '../../../theme';
import { pxToRem } from '../../../utils';
import { Text } from '../../Typography';
import { Input } from '../Input';

import { MoneyInput } from './MoneyInput';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
const Separator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${pxToRem(30)};
  color: ${palette.grayscale.shade700};
`;

const MinMoneyInputField = styled(Input)`
  text-align: center;
  border-radius: 0;
  border: 1px solid transparent;
  background-color: transparent;
`;

const MinMoneyInputFieldRounded = styled(MinMoneyInputField)`
  border-radius: ${pxToRem(5)} 0 0 ${pxToRem(5)};
`;

const MaxMoneyInputField = styled(Input)`
  text-align: center;
  border-radius: 0 ${pxToRem(5)} ${pxToRem(5)} 0;
  border: 1px solid transparent;
  background-color: transparent;
`;

interface IRangeFieldProps {
  values: { minAmount: number | null; maxAmount: number | null };
  prefix?: string;
  onChange?: (moneyRange: {
    minAmount: number | null;
    maxAmount: number | null;
  }) => void;
  onBlur?: () => void;
  placeholders?: { minAmount: string; maxAmount: string };
  label?: string;
  disabled?: boolean;
  radio?: boolean;
}
export function RangeField({
  values,
  prefix,
  onChange,
  onBlur,
  placeholders,
  disabled,
  radio,
}: IRangeFieldProps) {
  return (
    <Wrapper>
      <MoneyInput
        value={values.minAmount}
        prefix={prefix}
        customInput={radio ? MinMoneyInputFieldRounded : MinMoneyInputField}
        placeholder={placeholders?.minAmount}
        onBlur={onBlur}
        onChange={
          onChange && ((minAmount) => onChange({ ...values, minAmount }))
        }
        disabled={disabled}
      />
      <Separator>
        <Text>-</Text>
      </Separator>
      <MoneyInput
        value={values.maxAmount}
        prefix={prefix}
        customInput={MaxMoneyInputField}
        placeholder={placeholders?.maxAmount}
        onBlur={onBlur}
        onChange={
          onChange && ((maxAmount) => onChange({ ...values, maxAmount }))
        }
        disabled={disabled}
      />
    </Wrapper>
  );
}
